var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pageBlocks),function(ref,index){
var component = ref.component;
var props = ref.props;
var type = ref.type;
var title = ref.title;
var nobody = ref.nobody;
return _c(component,_vm._b({key:("block-" + index),tag:"component",attrs:{"title":title,"nobody":nobody,"block-index":index,"type":type}},'component',Object.assign({}, props),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }